var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3648 11.6991C20.3648 14.1593 18.3165 16.1538 15.7897 16.1538C13.263 16.1538 11.2146 14.1593 11.2146 11.6991C11.2146 9.23878 13.263 7.24433 15.7897 7.24433C18.3165 7.24433 20.3648 9.23878 20.3648 11.6991Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2.07887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23828 11.699C3.18159 5.6746 8.96187 1.30469 15.7904 1.30469C22.6189 1.30469 28.3992 5.67465 30.3425 11.6991C28.3992 17.7235 22.6189 22.0934 15.7904 22.0934C8.96187 22.0934 3.18155 17.7235 1.23828 11.699Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2.07887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.a63f7423bbf64679b3fd3f014381bf23.svg";
export { ForwardRef as ReactComponent };